export default [
    {
        date: 1509408341613,
        row: 41,
        col: 49,
        squares: [
            [1, 21, "#000000"],
            [1, 22, "#000000"],
            [1, 23, "#000000"],
            [2, 20, "#000000"],
            [2, 24, "#000000"],
            [3, 19, "#000000"],
            [4, 19, "#000000"],
            [3, 25, "#000000"],
            [4, 26, "#000000"],
            [5, 27, "#000000"],
            [6, 27, "#000000"],
            [7, 28, "#000000"],
            [8, 28, "#000000"],
            [8, 29, "#000000"],
            [9, 30, "#000000"],
            [10, 31, "#000000"],
            [10, 32, "#000000"],
            [11, 32, "#000000"],
            [10, 33, "#000000"],
            [10, 34, "#000000"],
            [11, 35, "#000000"],
            [11, 37, "#000000"],
            [11, 38, "#000000"],
            [5, 18, "#000000"],
            [6, 18, "#000000"],
            [7, 17, "#000000"],
            [8, 17, "#000000"],
            [9, 17, "#000000"],
            [10, 17, "#000000"],
            [11, 17, "#000000"],
            [12, 17, "#000000"],
            [13, 16, "#000000"],
            [14, 15, "#000000"],
            [15, 14, "#000000"],
            [16, 14, "#000000"],
            [17, 14, "#000000"],
            [18, 13, "#000000"],
            [19, 13, "#000000"],
            [20, 13, "#000000"],
            [21, 13, "#000000"],
            [22, 13, "#000000"],
            [23, 13, "#000000"],
            [24, 13, "#000000"],
            [25, 13, "#000000"],
            [25, 12, "#000000"],
            [25, 11, "#000000"],
            [25, 10, "#000000"],
            [26, 9, "#000000"],
            [27, 7, "#000000"],
            [27, 8, "#000000"],
            [26, 7, "#000000"],
            [24, 7, "#000000"],
            [25, 7, "#000000"],
            [23, 6, "#000000"],
            [22, 6, "#000000"],
            [21, 6, "#000000"],
            [20, 6, "#000000"],
            [19, 6, "#000000"],
            [18, 6, "#000000"],
            [17, 6, "#000000"],
            [16, 5, "#000000"],
            [15, 4, "#000000"],
            [14, 3, "#000000"],
            [14, 2, "#000000"],
            [15, 1, "#000000"],
            [16, 1, "#000000"],
            [17, 1, "#000000"],
            [18, 1, "#000000"],
            [19, 1, "#000000"],
            [20, 1, "#000000"],
            [21, 1, "#000000"],
            [22, 1, "#000000"],
            [23, 2, "#000000"],
            [24, 2, "#000000"],
            [25, 3, "#000000"],
            [26, 3, "#000000"],
            [27, 3, "#000000"],
            [28, 3, "#000000"],
            [29, 4, "#000000"],
            [30, 4, "#000000"],
            [31, 5, "#000000"],
            [32, 6, "#000000"],
            [32, 7, "#000000"],
            [33, 7, "#000000"],
            [34, 7, "#000000"],
            [35, 7, "#000000"],
            [36, 8, "#000000"],
            [37, 8, "#000000"],
            [38, 8, "#000000"],
            [39, 8, "#000000"],
            [40, 10, "#000000"],
            [40, 9, "#000000"],
            [41, 10, "#000000"],
            [41, 11, "#000000"],
            [41, 12, "#000000"],
            [41, 13, "#000000"],
            [41, 14, "#000000"],
            [41, 15, "#000000"],
            [41, 16, "#000000"],
            [41, 17, "#000000"],
            [40, 14, "#000000"],
            [40, 16, "#000000"],
            [40, 18, "#000000"],
            [39, 18, "#000000"],
            [38, 17, "#000000"],
            [38, 16, "#000000"],
            [41, 19, "#000000"],
            [41, 20, "#000000"],
            [41, 21, "#000000"],
            [41, 22, "#000000"],
            [40, 22, "#000000"],
            [41, 23, "#000000"],
            [41, 24, "#000000"],
            [40, 24, "#000000"],
            [41, 25, "#000000"],
            [40, 26, "#000000"],
            [39, 26, "#000000"],
            [38, 26, "#000000"],
            [41, 27, "#000000"],
            [41, 28, "#000000"],
            [41, 29, "#000000"],
            [41, 30, "#000000"],
            [40, 28, "#000000"],
            [40, 30, "#000000"],
            [40, 31, "#000000"],
            [39, 31, "#000000"],
            [37, 25, "#000000"],
            [37, 24, "#000000"],
            [36, 26, "#000000"],
            [35, 26, "#000000"],
            [36, 27, "#000000"],
            [36, 28, "#000000"],
            [36, 29, "#000000"],
            [36, 30, "#000000"],
            [36, 31, "#000000"],
            [38, 30, "#000000"],
            [37, 30, "#000000"],
            [36, 32, "#000000"],
            [36, 33, "#000000"],
            [36, 34, "#000000"],
            [12, 36, "#000000"],
            [13, 36, "#000000"],
            [12, 39, "#000000"],
            [13, 39, "#000000"],
            [14, 39, "#000000"],
            [15, 39, "#000000"],
            [14, 40, "#000000"],
            [15, 41, "#000000"],
            [15, 42, "#000000"],
            [15, 43, "#000000"],
            [15, 44, "#000000"],
            [15, 45, "#000000"],
            [15, 46, "#000000"],
            [16, 47, "#000000"],
            [16, 48, "#000000"],
            [17, 49, "#000000"],
            [18, 49, "#000000"],
            [19, 49, "#000000"],
            [20, 49, "#000000"],
            [21, 48, "#000000"],
            [22, 48, "#000000"],
            [23, 47, "#000000"],
            [24, 47, "#000000"],
            [25, 46, "#000000"],
            [26, 45, "#000000"],
            [27, 44, "#000000"],
            [28, 44, "#000000"],
            [29, 44, "#000000"],
            [30, 44, "#000000"],
            [31, 43, "#000000"],
            [32, 43, "#000000"],
            [33, 42, "#000000"],
            [34, 41, "#000000"],
            [35, 40, "#000000"],
            [35, 39, "#000000"],
            [36, 35, "#000000"],
            [36, 36, "#000000"],
            [36, 37, "#000000"],
            [36, 38, "#000000"],
            [6, 21, "#FF00FF"],
            [6, 22, "#FF00FF"],
            [7, 20, "#FF00FF"],
            [7, 21, "#FF00FF"],
            [7, 22, "#FF00FF"],
            [7, 23, "#FF00FF"],
            [8, 20, "#FF00FF"],
            [8, 21, "#FF00FF"],
            [8, 22, "#FF00FF"],
            [8, 23, "#FF00FF"],
            [8, 24, "#FF00FF"],
            [9, 24, "#FF00FF"],
            [9, 23, "#FF00FF"],
            [9, 22, "#FF00FF"],
            [9, 21, "#FF00FF"],
            [9, 20, "#FF00FF"],
            [26, 14, "#000000"],
            [27, 14, "#000000"],
            [28, 15, "#000000"],
            [27, 16, "#FF00FF"],
            [26, 16, "#FF00FF"],
            [25, 17, "#FF00FF"],
            [28, 17, "#FF00FF"],
            [28, 18, "#FF00FF"],
            [27, 19, "#FF00FF"],
            [26, 17, "#9900FF"],
            [27, 17, "#9900FF"],
            [27, 18, "#9900FF"],
            [26, 18, "#9900FF"],
            [25, 18, "#000000"],
            [24, 18, "#000000"],
            [23, 18, "#000000"],
            [22, 18, "#000000"],
            [26, 19, "#000000"],
            [26, 20, "#000000"],
            [26, 21, "#000000"],
            [26, 22, "#000000"],
            [25, 23, "#000000"],
            [25, 22, "#000000"],
            [25, 21, "#00FFFF"],
            [24, 20, "#00FFFF"],
            [22, 19, "#00FFFF"],
            [21, 20, "#00FFFF"],
            [21, 21, "#00FFFF"],
            [21, 19, "#000000"],
            [20, 20, "#000000"],
            [20, 21, "#000000"],
            [20, 22, "#000000"],
            [21, 22, "#000000"],
            [21, 23, "#000000"],
            [22, 24, "#000000"],
            [23, 24, "#000000"],
            [24, 24, "#000000"],
            [24, 23, "#000000"],
            [24, 22, "#000000"],
            [24, 21, "#000000"],
            [23, 21, "#000000"],
            [22, 21, "#000000"],
            [22, 20, "#000000"],
            [23, 20, "#000000"],
            [23, 19, "#000000"],
            [24, 19, "#000000"],
            [25, 19, "#000000"],
            [25, 20, "#000000"],
            [27, 25, "#000000"],
            [28, 26, "#000000"],
            [28, 27, "#000000"],
            [26, 27, "#FF00FF"],
            [18, 46, "#FF00FF"],
            [18, 45, "#FF00FF"],
            [19, 43, "#FF00FF"],
            [19, 44, "#FF00FF"],
            [19, 45, "#FF00FF"],
            [19, 46, "#FF00FF"],
            [20, 46, "#FF00FF"],
            [21, 46, "#FF00FF"],
            [20, 43, "#FF00FF"],
            [20, 44, "#FF00FF"],
            [20, 45, "#FF00FF"],
            [21, 45, "#FF00FF"],
            [21, 44, "#FF00FF"],
            [21, 43, "#FF00FF"],
            [22, 45, "#FF00FF"],
            [22, 44, "#FF00FF"],
            [22, 43, "#FF00FF"],
            [23, 43, "#FF00FF"],
            [23, 44, "#FF00FF"],
            [32, 38, "#FF00FF"],
            [31, 38, "#FF00FF"],
            [33, 37, "#FF00FF"],
            [33, 36, "#FF00FF"],
            [32, 35, "#FF00FF"],
            [32, 36, "#9900FF"],
            [32, 37, "#9900FF"],
            [31, 37, "#9900FF"],
            [31, 36, "#9900FF"],
            [31, 35, "#000000"],
            [31, 34, "#000000"],
            [31, 33, "#000000"],
            [30, 32, "#000000"],
            [29, 32, "#000000"],
            [28, 32, "#000000"],
            [27, 32, "#000000"],
            [26, 33, "#000000"],
            [25, 34, "#000000"],
            [25, 35, "#000000"],
            [25, 36, "#000000"],
            [26, 37, "#000000"],
            [27, 38, "#000000"],
            [28, 38, "#000000"],
            [29, 38, "#000000"],
            [30, 37, "#000000"],
            [27, 37, "#00FFFF"],
            [28, 37, "#00FFFF"],
            [29, 37, "#00FFFF"],
            [28, 33, "#00FFFF"],
            [29, 34, "#00FFFF"],
            [27, 33, "#000000"],
            [28, 34, "#000000"],
            [28, 35, "#000000"],
            [27, 36, "#000000"],
            [26, 36, "#000000"],
            [28, 36, "#000000"],
            [29, 36, "#000000"],
            [29, 35, "#000000"],
            [30, 35, "#000000"],
            [30, 36, "#000000"],
            [30, 34, "#000000"],
            [30, 33, "#000000"],
            [29, 33, "#000000"],
        ],
    },
];
